/**
 * Reprezentuje obálku zprávy DataEvent.
 * DataEvents je proprietární systém posílání realtime zpráv mezi klientskou aplikací a webovou službou.
 * @see https://teaf.tescosw.cz/wiki/index.php?title=DataEvents
 * @includeToDoc
 */
export interface IDataEvent {
    /** Označení typu zprávy */
    messageType: "DataEvent" | string;
    /** Název zdroje, ze kterého zpráva pochází. Webová služba TEAF používá "OW", ale obecně zpráva může přijít i z dalších služeb. */
    source: string;
    /** Přijatá zpráva */
    message: IDataEventMessage;
}

/**
 * Zpráva DataEvent, její typ a obsah
 * @includeToDoc
 */
export interface IDataEventMessage {
    /** Typ zprávy */
    type: string;
    /** Podtyp zprávy zpřesňující její význam */
    subType: string | null;
    /** Čas vzniku zprávy */
    time: string;
    /** Tělo zprávy, může obsahovat hodnotu primitivních datových typů, ale i JSON objekty */
    body: unknown | null;
    /** Id aplikačního záznamu, kterého se zpráva týká */
    id: string | null;
}
